import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import cn from "classnames";
import queryString from "query-string";

import styles from "./pageNames.module.css";

const PageNames = ({ isListingsPage }) => {
  const location = useLocation();

  const searchParams = queryString.parse(location.search);

  return (
    <div className={cn(styles.main, isListingsPage ? styles.mainListings : "")}>
      <NavLink to="/" className={({ isActive }) => cn(styles.link, { [styles.activeLink]: isActive })}>
        Feed
      </NavLink>

      <NavLink to="/saved" className={({ isActive }) => cn(styles.link, { [styles.activeLink]: isActive })}>
        Saved
      </NavLink>

      <NavLink to="/inbox" className={({ isActive }) => cn(styles.link, { [styles.activeLink]: isActive })}>
        {searchParams.tab === "archived" ? "Archived messages" : "All messages"}
      </NavLink>
    </div>
  );
};

export default PageNames;
